export const access: object = {
  access: {
    mainMessage: 'Access Denied',
    additionalMessage: 'You don\'t have permission to access this page',
    returnMainPage: 'Return to Homepage'
  }
};
